<div class="container-map">
    <img src="../../../../../assets/landing-social-proof/mapa.png" alt="" width="1100" height="680">
</div>
